import { forwardRef } from "react"
import classNames from "classnames"
import { mergeClasses } from "@lib/css"

import type {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  ElementType,
  ReactNode,
} from "react"

type ButtonElement = HTMLButtonElement | HTMLAnchorElement

export type ButtonProps = {
  as?: ElementType
  children: ReactNode | ReactNode[]
  className?: string
} & ButtonHTMLAttributes<ButtonElement> &
  AnchorHTMLAttributes<HTMLAnchorElement>

const baseClasses =
  "h-15 inline-flex items-center justify-center font-sans-bold text-sm leading-4 tracking-wide uppercase transition-colors duration-100 ease-in cursor-pointer"

export const ButtonContained = forwardRef<HTMLButtonElement, ButtonProps>(
  function ButtonPrimaryView(props, ref) {
    const { as: Element = "button", children, className, ...otherProps } = props

    const defaultClasses = classNames(
      baseClasses,
      "text-white bg-black border-none",
      "tablet:hover:bg-gray-300",
      "disabled:bg-gray-150",
    )

    const classes = mergeClasses(defaultClasses, className)

    return (
      <Element ref={ref} className={classes} {...otherProps}>
        {children}
      </Element>
    )
  },
)

export const ButtonText = forwardRef<HTMLButtonElement, ButtonProps>(
  function ButtonPrimaryView(props, ref) {
    const { as: Element = "button", children, className, ...otherProps } = props

    const defaultClasses = classNames(
      baseClasses,
      "text-black bg-transparent border-none",
      "hover:text-gray-280 active:text-gray-250 focus:text-gray-250",
      "disabled:bg-text-150",
    )

    const classes = mergeClasses(defaultClasses, className)

    return (
      <Element ref={ref} className={classes} {...otherProps}>
        {children}
      </Element>
    )
  },
)
